import { render } from "./PdfPageBreak.vue?vue&type=template&id=5521c14a"
import script from "./PdfPageBreak.vue?vue&type=script&lang=js"
export * from "./PdfPageBreak.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__